module.exports = __webpack_public_path__ + "static/media/google-drive-icon.45590804.svg";